import { acceptHMRUpdate, defineStore } from "pinia";
import { popupStoreData } from "@core/ui/popupDialog.store";
import { useModelStore } from "@editor/items/model/model.store";

import type {
  OverlayItemType,
  OverlayDialogItem,
  OverlayDialogItemRequest
} from "./OverlayDialogItem";

export const useOverlay = defineStore("ui/overlay", {
  state: () => ({
    ...popupStoreData.state(),
    item: null as null | OverlayDialogItem
  }),
  actions: {
    ...popupStoreData.actions,

    setItem<T extends OverlayItemType>(
      item: OverlayDialogItemRequest<T> | null
    ) {
      if (item) {
        const type = item.type;
        if (type == "question" || type == "model") {
          this.item = { type };
        } else {
          const resolvedItem = useModelStore().getItem(
            type as Exclude<T, "question" | "model">,
            item.id
          );

          if (!resolvedItem) {
            console.warn(`Item ${item.type} ${item.id} not found`);
          }

          this.item = resolvedItem;
        }
        this.open();
      } else {
        this.hide();
      }
    },
    hide() {
      this.item = null;
      this.close();
    }
  }
});

if (import.meta.hot) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  import.meta.hot.accept(acceptHMRUpdate(useOverlay as any, import.meta.hot));
}
